import _ from 'lodash';

export default function selector(storeState, props) {
    const audienceSegmentOptions = _.get(storeState, 'audienceSegmentPicker.audienceSegments');
    const flexSegmentsOptions = _.get(storeState, 'audienceSegmentPicker.flexSegments');
    const ownOrganizationId = _.get(storeState, 'profile.organizationId');
    const isLoading = _.get(storeState, 'audienceSegmentPicker.isLoading');
    const campaign = _.get(storeState, `resources.campaigns.${props.campaignId}.attr`);

    return {
        audienceSegmentOptions,
        ownOrganizationId,
        isLoading,
        flexSegmentsOptions,
        shouldHideFlexSegments: _.isNil(campaign)
            ? false
            : _.get(campaign, 'shouldHideFlexSegments'),
        isCrossPlatformCampaign: _.isNil(campaign)
            ? true
            : _.get(campaign, 'isCrossPlatformCampaign'),
    };
}

